import * as React from 'react';
import { ActivityComponentProps } from './ActivityComponentProps';
import { ActivityDetailsPanel } from './ActivityDetailsPanel';
import { AgendaItemListPanel } from './AgendaItemListPanel';
import { fieldValidation } from '../../../amorg-common';
import { updateActivity } from '../../../api/activityClientApi';
import { LoadingPageOverlay } from '../../../designSystem/LoadingPageOverlay';
import { CollapsiblePanel } from '../../../designSystem/collapsible/CollapsiblePanel';
import { EditableText } from '../../../designSystem/compositeComponents/EditableText';
import { ActivityHeader } from './ActivityHeader';
import { SingleColumnLayout } from '../../../designSystem/layouts/SingleColumnLayout';
import { Card } from '../../../designSystem/Card';
import { ReferenceFilesPanelCollapsible } from '../../../designSystem/compositeComponents/ReferenceFilesPanel';
import { ReferenceLinksPanelCollapsible } from '../../../designSystem/compositeComponents/ReferenceLinksPanel';
import { Flex } from '../../../designSystem/compositeComponents/FlexHelpers';



export default function AgendaMeetingActivityView (props: ActivityComponentProps): JSX.Element 
{
    const [loading, setLoading] = React.useState(true);

    async function isLoading (value: boolean)
    {
        setLoading(value);
    }

    async function handleActivityUpdated ()
    {
        setLoading(true);
        props.onActivityUpdated();
        // setInvitationStatus(await getMeetingInvitationStatus(props.activity.id));
        setLoading(false);
    }

    async function updateTitle (value: string)
    {
        await updateActivity(props.activity.id, value, props.activity.description, props.activity.start, props.activity.end, props.activity.location);
        props.onActivityUpdated();
    }

    return (
        <>
            <SingleColumnLayout
                noDivider
                contentContainer={
                    <>
                        <ActivityHeader
                            activity={props.activity}
                            deleteConfirmationTextInModal="Tilhørende handlepunkter vil ligeledes blive slettet."
                            onActivityUpdated={handleActivityUpdated}
                            isLoading={isLoading} />

                        <CollapsiblePanel
                            defaultOpen={true}
                            closedOrDefaultHeader={
                                <TitleContainer title={props.activity.title} updateTitle={updateTitle} />
                            }>
                            <Card variant="outlined">

                                <ActivityDetailsPanel
                                    activity={props.activity}
                                    descriptionText="Mødebeskrivelse"
                                    periodSelection='date-time'
                                    onActivityUpdated={handleActivityUpdated}
                                    componentTitle='Møde info'
                                    users={props.users}
                                    participantTexts={{ header: 'Deltagere', editButton: 'Rediger deltagere' }}
                                    infoComponents={
                                        <>
                                            <LoadingPageOverlay loading={loading} />
                                        </>
                                    } />

                                <Flex gap={16} flexDirection="column">
                                    <ReferenceFilesPanelCollapsible objectId={props.activity.id} referenceType="Meeting" />

                                    <ReferenceLinksPanelCollapsible reference={ { id: props.activity.id, type: "Meeting" } } />
                                </Flex>
                                
                            </Card>
                        </CollapsiblePanel>

                        <AgendaItemListPanel
                            activityId={props.activity.id}
                            agendaItems={props.activity.agendaItems}
                            users={props.users}
                            onUpdated={handleActivityUpdated} />
                    </>
                } />
        </>
    );
}

type TitleContainerProps = {
    title: string;
    updateTitle: (value: string) => void;
};

export function TitleContainer (props: TitleContainerProps)
{
    return (

        <EditableText
            ariaLabel='mødetitel'
            value={props.title}
            validator={(currentValue) =>
            {
                if (fieldValidation.activity.title(currentValue))
                    return { valid: true };
                return { valid: false, errorMessage: `Ugyldig titel. Skal udfyldes med maks. 100 (${currentValue.length}) tegn.` };
            }}
            onSave={async (value) =>
            {
                if (fieldValidation.activity.title(value))
                    props.updateTitle(value);
            }}
            styleMode='H2'
            placeholder="Indtast overskrift" />

    );
}